module.exports = __webpack_public_path__ + "static/media/DSCF0382-2HtoiYgs.e4e9ab02.JPG";